import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class AcceptRefund {
  public constructor(@inject(HttpClient) private readonly httpClient: HttpClient) {}

  public async execute(id: string): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.PATCH,
      url: `${Envs.BFF_WEB_URL}/refunds/${id}/accept`,
    })

    if ([HttpStatusCode.OK, HttpStatusCode.CREATED].includes(response.statusCode)) {
      return response.data
    } else {
      throw new GeneralError()
    }
  }
}
